import React from 'react';

interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
}

export const SectionCard = ({ children, className = '' }: SectionCardProps) => {
  return (
    <div
      className={`bg-transparent border border-spring-neutral-b4 rounded-lg p-2 ${className}`}
    >
      {children}
    </div>
  );
};
